
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/alternatives/bolosign-vs-signwell",
      function () {
        return require("private-next-pages/signature/alternatives/bolosign-vs-signwell.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/alternatives/bolosign-vs-signwell"])
      });
    }
  